import { z } from 'zod';

import { CatalogDefaultAccountKeysBodySchema } from './product.schemas.js';

export const RegisterProductFieldsSchema = z
  .object({
    name: z.string().trim().min(1).max(255),
    categoryId: z.uuid().optional(),
    productTypeId: z.uuid().optional(),
    brandId: z.uuid().optional(),
    manufacturerId: z.uuid().optional(),
    catalogManufacturerId: z.uuid().optional(),
    measurementUnitId: z.uuid().optional(),
    catalogMeasurementUnitId: z.uuid().optional(),
    sku: z.string().trim().max(50).optional(),
    stockControl: z.boolean().default(true),
    manufacturerCode: z.string().trim().max(100).optional(),
    packageBarcode: z.string().trim().max(100).optional(),
    unitBarcode: z.string().trim().max(100).optional(),
    qrCode: z.string().trim().max(100).optional(),
    grossWeightGrams: z.number().int().nonnegative().optional(),
    netWeightGrams: z.number().int().nonnegative().optional(),
    usefulLifeMeters: z.number().int().nonnegative().optional(),
    usefulLifeMonths: z.number().int().nonnegative().optional(),
    alertMeters: z.number().int().nonnegative().optional(),
    alertMonths: z.number().int().nonnegative().optional(),
    warrantyMonths: z.number().int().nonnegative().optional(),
    warrantyMeters: z.number().int().nonnegative().optional(),
    warrantyTerms: z.string().trim().max(5000).optional(),
    notes: z.string().trim().max(5000).optional(),
    /** BR-PRD-27/29 — produto privado nunca gera candidato ao catálogo global. */
    privateFlag: z.boolean().optional(),
    /** BR-PRD-106 — optional overlay: persist the tenant copy already linked. */
    catalogProductId: z.uuid().optional(),
    genericProductId: z.uuid().nullable().optional(),
  })
  .extend(CatalogDefaultAccountKeysBodySchema.shape);

export const RegisterProductBodySchema = RegisterProductFieldsSchema.refine(
  (body) => !(body.manufacturerId !== undefined && body.catalogManufacturerId !== undefined),
  { message: 'manufacturer ref is exclusive' },
).refine(
  (body) => !(body.measurementUnitId !== undefined && body.catalogMeasurementUnitId !== undefined),
  { message: 'measurement unit ref is exclusive' },
);

export const RegisterProductResponseSchema = z.object({
  productId: z.uuid(),
});

export type RegisterProductBody = z.infer<typeof RegisterProductBodySchema>;
export type RegisterProductResponse = z.infer<typeof RegisterProductResponseSchema>;
